import { AdviceProductDetailsFormValues } from "Features/CheckPrice/Products/Advice/ProductDetails/FormElements/interfaces";
import { useAdviceDetailsFormValues } from "Features/CheckPrice/Products/Advice/ProductPrice/hooks/stateSelectors";
import { Description } from "Features/CheckPrice/Products/Advice/adviceStyled";
import { isEmpty } from "Utils/functions";
import React from "react";

interface Props {
  adviceTexts: any;
  lang: string;
}

export const DisabilityAdviceIntroHeader = ({
  adviceTexts,
  lang,
}: Props): React.ReactElement => {
  const detailsFormValues =
    useAdviceDetailsFormValues() as AdviceProductDetailsFormValues;
  const hasDebt = detailsFormValues.debt > 0;
  const hasChildren = !isEmpty(detailsFormValues.childDatesOfBirth);

  const { header } = adviceTexts;
  const thisInsuranceHelpsWith = header.part1[lang];
  let theFollowing = header.part2.other[lang];
  if (hasDebt && hasChildren) {
    theFollowing = header.part2.debtAndChildren[lang];
  } else if (hasDebt) {
    theFollowing = header.part2.debt[lang];
  } else if (hasChildren) {
    theFollowing = header.part2.children[lang];
  }
  return (
    <div className="AdviceHeaderText">
      <Description fw={600} size="16px">
        {thisInsuranceHelpsWith}
        {theFollowing}
      </Description>
    </div>
  );
};
